import getLanguageAndCountryCodeFromLocale from "@secureo/common/utils/i18n/getLanguageAndCountryCodeFromLocale"
import { getLocalizedDimensions } from "../utils/formatDimensions"

const localizedDimensionPrefixesByLanguage = {
	de: {
		height: "H ",
		width: "B ",
		depth: "T ",
	},
	en: {
		height: "H ",
		width: "W ",
		depth: "D ",
	},
	pl: {
		height: "W ",
		width: "S ",
		depth: "G ",
	},
}

const getLocalizedDimensionPrefix = (
	dimension: "width" | "height" | "depth",
	language: string,
): string => {
	return (
		localizedDimensionPrefixesByLanguage[language][dimension] ??
		localizedDimensionPrefixesByLanguage.de[dimension]
	)
}

const prefix = (dimension: string, prefix: string) => `${prefix} ${dimension}`

const Dimensions = ({ depth, height, width, locale }: Props) => {
	const { localizedWidth, localizedHeight, localizedDepth } = getLocalizedDimensions(
		width,
		height,
		depth,
		locale,
	)
	const { language } = getLanguageAndCountryCodeFromLocale(locale)

	const formattedHeight = localizedHeight
		? prefix(localizedHeight, getLocalizedDimensionPrefix("height", language))
		: null
	const formattedWidth = localizedWidth
		? prefix(localizedWidth, getLocalizedDimensionPrefix("width", language))
		: null
	const formattedDepth = localizedDepth
		? prefix(localizedDepth, getLocalizedDimensionPrefix("depth", language))
		: null

	const dimensions = [formattedHeight, formattedWidth, formattedDepth].filter(
		(dimension) => !!dimension,
	)

	const dimensionString = dimensions.join(" x ")

	return <span>{dimensionString}</span>
}

interface Props {
	depth: number
	height: number
	width: number
	locale: string
}

export default Dimensions
